import { AuthUserFragment } from './__generated__/GetInitialInfo.graphql';

export const INITIAL_INFO_NAME = 'GetInitialInfo';

export type AuthUser = DeeplyDefined<AuthUserFragment>;
